import { PageMargin } from '~src/branding/spacing';
import { BODIL_ENERGI } from '~src/constants';

import { Logo, Navigation, NavigationItem, StyledHeader } from './style';
import { useBranding } from '~src/context/BrandingContext';
import { useDisplayContext } from '~src/context/DisplayContext';

const links = [
  { title: 'Spørgsmål og Svar', href: `${BODIL_ENERGI}/faq` },
  { title: 'Om Bodil', href: `${BODIL_ENERGI}/om-bodil` },
  { title: 'Blog', href: `${BODIL_ENERGI}/blog` },

  { title: 'Bliv ringet op', href: `${BODIL_ENERGI}/kontakt`, uppercase: true },
];

type Props = { margin?: PageMargin };

export const Header = ({ margin }: Props) => {
  const { logoURL } = useBranding();

  const { leadOrigin } = useDisplayContext();

  return (
    <StyledHeader {...{ margin }}>
      <Logo href={`/${leadOrigin}`} src={logoURL} />
      <Navigation>
        {links.map(({ title, href, uppercase }) => (
          <NavigationItem style={{ textTransform: uppercase ? 'uppercase' : undefined }} key={title} href={href}>
            {title}
          </NavigationItem>
        ))}
      </Navigation>
    </StyledHeader>
  );
};
